import React, { useState } from "react";
import config from "../../Config";
import axios from "axios";
import LibraryMenu from './LibraryMenu';
import LibraryCategorySelect from './LibraryCategorySelect';
import { NavLink, useNavigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";

function AddBook(props) {

    const [AccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID] = useState(localStorage.getItem("ID"));
    const [MemberType] = useState(localStorage.getItem("MemberType"));
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState("");
    const [coverPreview, setCoverPreview] = useState("");
    const [coverBase64, setCoverBase64] = useState("");

    document.title = 'Add Book'

    let navigate = useNavigate();

    const onCoverChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
            setCoverPreview(reader.result);
            setCoverBase64(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleSubmit = (event) => {

        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            setLoading(true);
            const data = {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                Book_No: event.target.txtBookNo.value,
                Book_Name: event.target.txtBookName.value,
                Writer_Name: event.target.txtWriterName.value,
                Publisher_Name: event.target.txtPublisherName.value,
                Category: category,
                Edition: event.target.txtEdition.value,
                Total_Pages: event.target.txtTotalPages.value,
                Binding_Type: event.target.txtBindingType.value,
                Price: event.target.txtPrice.value,
                Purchasing_Source: event.target.txtPurchasingSource.value,
                Title_Image: coverBase64 || "",
                Jild_No: event.target.txtJildNo.value,
                Current_Status: "Available",
                Remarks: event.target.txtRemarks.value,
            };

            var api_config = {
                method: 'post',
                url: config.base_url + 'Library/AddLibrary',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios(api_config)
                .then(function (response) {
                    if (response.data.status_code == 1) {
                        toast.success(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        navigate('/Library/ViewLibrary');
                    }
                    else {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                    }
                    setLoading(false);
                })
                .catch(function (error) {
                    setLoading(false);
                    toast.error('Network Error..', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                });
        }

        setValidated(true);
    };


    return (
        <>
            <LibraryMenu />
            <ToastContainer />
            <div className="container body-content">
                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to="/Dashboard">Dashboard</NavLink></li>
                                        <li className="breadcrumb-item"><NavLink to="/Library/LibraryDashboard">Library</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Add Library Book</li>
                                    </ol>
                                </nav>
                                <div className="page-title">Add Library Book</div>
                            </div>
                            <div className="col-md-6">
                                <div className="page-right-actions">
                                    <NavLink to="/Library/ImportBooks" className="button button-white button-icon me-2">
                                        Import Books
                                        <i className="ri-upload-2-line"></i>
                                    </NavLink>
                                    <NavLink to="/Library/ViewLibrary" className="button button-white button-icon">
                                        Manage Library
                                        <i className="ri-file-list-2-line"></i>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body card-form-wrap">
                                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                            <div className="row align-items-center">
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Book No:</label>
                                                        <input type="text" className="form-control" name="txtBookNo" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Book Name:</label>
                                                        <input type="text" name="txtBookName" className="form-control" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Writer Name:</label>
                                                        <input type="text" name="txtWriterName" className="form-control" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Publisher Name:</label>
                                                        <input type="text" name="txtPublisherName" className="form-control" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Classification / Category:</label>
                                                        <LibraryCategorySelect
                                                            value={category}
                                                            onChange={(e) => setCategory(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Edition:</label>
                                                        <input type="text" name="txtEdition" className="form-control" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>No of Pages:</label>
                                                        <input type="number" name="txtTotalPages" className="form-control" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Binding Type:</label>
                                                        <select className="form-select" name="txtBindingType" defaultValue="Not Available" required>
                                                            <option value="Not Available">Not Available</option>
                                                            <option value="Tape Binding">Tape Binding</option>
                                                            <option value="Hard Binding">Hard Binding</option>
                                                            <option value="Paper Binding">Paper Binding</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Book Price:</label>
                                                        <input type="number" name="txtPrice" className="form-control" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Jild No:</label>
                                                        <input type="text" name="txtJildNo" className="form-control" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Purchasing Source:</label>
                                                        <input type="text" name="txtPurchasingSource" className="form-control" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group mb-3">
                                                        <label>Book Cover (optional):</label>
                                                        <input type="file" className="form-control" accept="image/*" onChange={onCoverChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    {coverPreview && (
                                                        <img src={coverPreview} alt="Cover preview" className="img-fluid rounded" style={{ maxHeight: "120px" }} />
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label>Remarks:</label>
                                                        <input type="text" name="txtRemarks" className="form-control" />
                                                    </div>
                                                </div>
                                                <div className="col-md-3 offset-md-3 text-end mt-md-3">
                                                    <div className="form-group">
                                                        {
                                                            loading ?
                                                                <Spinner animation="border" role="status"></Spinner>
                                                                :
                                                                <button type="submit" className="button button-primary w-100">SAVE</button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddBook;
